import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {startsWith} from '../../../../common/util/dropdown';

class GroupSelector extends Component {
  componentDidMount() {
    this.props.fetchGroupsList();
  }

  parseGroups(groups = []) {
    return groups.map((item) => ({'text': item[0], 'value': item[0]}));
  }

  render() {
    const {value, name, pncGroups, loading, changeValue} = this.props;

    return (
      <Dropdown
        selection
        fluid
        name={name}
        search={startsWith}
        value={value}
        loading={loading}
        disabled={loading}
        options={this.parseGroups(pncGroups)}
        onChange={changeValue}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.pncGroups.loading,
    'pncGroups': state.pncGroups.list,
  };
};

const {fetchGroupsList} = Actions;

export default connect(mapStateToProps, {fetchGroupsList})(GroupSelector);
